"use strict";

define('langs',['language/all_languages', 'libs/language.helper'], function (all_languages, LanguageHelper) {
  LanguageHelper.setup(all_languages);
  return LanguageHelper;
});

